// removed by extract-text-webpack-plugin
module.exports = {"welcome":"_1HC5-tqzfcJLhbYc1wzv-j","top_left":"_3IB6VBxAcnwrf6lEYWbwQL","top_right":"_3EHZRXGEDRmdLWBrciYkK-","ant-dropdown-link":"_2BUScc-BRn8fpRImp7Sv7Z","right_dropdown":"_2fQ70W161M7ZGvmxUjiA7J","header_top":"_1SzbIDPJimWTPs5gEs_vyK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/Include/header_top.css
// module id = 3029
// module chunks = 0